import { render, staticRenderFns } from "./step_description_complectyushie_rfrp.vue?vue&type=template&id=6cc8e64a&scoped=true"
import script from "./step_description_complectyushie_rfrp.vue?vue&type=script&lang=js"
export * from "./step_description_complectyushie_rfrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8e64a",
  null
  
)

export default component.exports